import { Link } from "react-router-dom";
import { LAWYERS, type Lawyer } from "src/constants/lawyers";

export function CompanyLawyers() {
  const representatives = LAWYERS.filter((l) => l.title === "대표 변호사");
  const members = LAWYERS.filter((l) => l.title !== "대표 변호사");

  return (
    <section className="px-4 pt-[76px] pb-[120px]">
      <div className="max-w-[1150px] mx-auto">
        <div className="flex flex-col gap-[196px]">
          <Lawyers
            title="대표 변호사"
            lawyers={representatives}
            priorityFirst
          />
          <Lawyers title="주요 구성원" lawyers={members} />
        </div>
      </div>
    </section>
  );
}

interface LawyersProps {
  title: string;
  lawyers: Lawyer[];
  // First card is the LCP element on /company; fetch it at high priority
  priorityFirst?: boolean;
}
function Lawyers({ title, lawyers, priorityFirst = false }: LawyersProps) {
  return (
    <div className="">
      <h2 className="text-heading-1-mb desktop:text-heading-1 mb-8">{title}</h2>
      <div className="grid grid-cols-1 tablet:grid-cols-3 gap-5 desktop:gap-6">
        {lawyers.map((lawyer, index) => (
          <Card
            key={index}
            lawyer={lawyer}
            priority={priorityFirst && index === 0}
          />
        ))}
      </div>
    </div>
  );
}
interface CardProps {
  lawyer: Lawyer;
  priority?: boolean;
}
function Card({ lawyer, priority = false }: CardProps) {
  return (
    <Link to={`/company/lawyers/${lawyer.slug}`} className="block">
      <article className="rounded-2xl overflow-hidden transition-all duration-300 hover:shadow-[0_4px_6px_rgba(0,0,0,0.07),0_10px_24px_rgba(0,0,0,0.12)] hover:-translate-y-1 cursor-pointer">
        {/* 이미지 + 태그 */}
        <figure className="relative h-[240px] tablet:h-60 desktop:h-[344px]">
          <img
            src={`/lawyer-${lawyer.slug}.webp`}
            fetchPriority={priority ? "high" : undefined}
            alt={`${lawyer.name} ${lawyer.title}`}
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
          <figcaption className="absolute bottom-4 right-4 text-white text-body-1-mb desktop:text-body-1 px-[10px] py-1 bg-white/20 rounded-[4px]">
            {lawyer.tag}
          </figcaption>
        </figure>

        {/* 이름 + 직함 + 경력 */}
        <div className="py-4 px-2">
          <div>
            <h3 className="text-heading-2-mb desktop:text-heading-2 text-[#506286]">
              {lawyer.name}
            </h3>
            <span className="text-heading-3-mb desktop:text-heading-3 !font-normal text-[#506286]">
              {lawyer.title}
            </span>
          </div>
          <div className="mt-2">
            <span className="text-caption-1-mb desktop:text-caption-1 text-[#506286]">
              경력
            </span>
            <p className="text-body-1-mb desktop:text-body-1 text-[#616269] truncate">
              {lawyer.career.join(", ")}
            </p>
          </div>
        </div>
      </article>
    </Link>
  );
}
